import { useAppDispatch, useAppSelector } from "hooks/redux";
import { useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import { metadataSuccess } from "app-component/slices/metadata-slice";
import { getExamModelListData, getListItemsWithListType } from "utils/metadata-split/metaDataApiFetch";
import { EntitiesRoutes } from "./routes";
import { checkFeatureAccess } from "utils/role-restriction/helper";
export interface IMatch {
  url: string;
}

export function EntitiesPage({ match }: { match: IMatch }) {
  const { isLoading, data: metaData }: any = useAppSelector(
    (state) => state.metadataReducer
  );

  const { profileData } = useAppSelector((state) => state.gmailLoginReducer);
  const { role: userRoleStr } = profileData;
  const userRole = userRoleStr?.split(",");

  const dispatch = useAppDispatch();
  const [showLoading, setShowIsLoading] = useState(true);

  const updateMetaData = (listData, metaKey,listData2, metaKey2) => {
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    metadataList[metaKey2] = listData2;
    dispatch(metadataSuccess(metadataList));
    setShowIsLoading(false);
  };

  useEffect(() => {}, [metaData]);

  useEffect(() => {
    (async () => {
      try {
        const call1: any = await getExamModelListData(updateMetaData);
        const call2:any=await getListItemsWithListType("platform_list","platform_list");
        updateMetaData(call1[0], call1[1],call2[0], call2[1]);
      } catch (error) {
      }
    })();
  }, []);

  if (showLoading) {
    return <p>loading....</p>;
  }
  return (
    <>
      <Switch>
      {EntitiesRoutes.map((route, i) => {
          return (
            checkFeatureAccess(userRole, route?.user) && (
              <Route
                key={i}
                exact
                path={`${match.url}${route.path}`}
                component={route.component}
              />
            )
          );
        })}
      </Switch>
    </>
  );
}
